<template>
  <h3 class="hint-text">
    <slot />
  </h3>
</template>

<style lang="postcss">
.hint-text {
  text-align: center;
  font-size: 0.7rem;
  margin-top: var(--attest-spacing-2);
  margin-bottom: calc(1rem + var(--attest-spacing-2));
  color: #036;
  font-weight: 400;
  letter-spacing: 0.18em;
}
</style>
